module.exports = __webpack_public_path__ + "img/home-rbn-6.bf7e19e6.png";